import { testForMetersFormat } from '@/entities/tech-map';
import * as yup from 'yup';

export const issueDetailsSchema = yup.object({
	date: yup.string().required('Заполните это поле, оно обязательное'),
	count: yup.number().required('Заполните это поле, оно обязательное'),
	receiver: yup.string().required('Заполните это поле, оно обязательное'),
	certificate: yup.string().required('Заполните это поле, оно обязательное'),
	fio: yup.string().required('Заполните это поле, оно обязательное'),
});

export const operationFillSchema = yup.object({
	step_id: yup.number().required('Заполните это поле, оно обязательное'),
	fio: yup.string().required('Заполните это поле, оно обязательное'),
	date: yup.string().required('Заполните это поле, оно обязательное'),
});

export const cancelOperationSchema = yup.object({
	operation_id: yup.number().required('Заполните это поле, оно обязательное'),
	closing_employee_fio: yup.number().required('Заполните это поле, оно обязательное'),
	date: yup.string().required('Заполните это поле, оно обязательное'),
});

export const assemblyOperationFillSchema = yup.object({
	id: yup.mixed().required('Заполните это поле, оно обязательное'),
	fio: yup.string().nullable(),
	date: yup.string().nullable(),
	count_in_number: yup.number().nullable(),
	count_out_number: yup
		.mixed()
		.nullable()
		.test('', 'count in number less then count out number', (val, ctx) => {
			if (!val) return true;
			if (
				(ctx.parent.count_in_number === '-' || ctx.parent.count_in_number === null) &&
				(val === '-' || !isNaN(Number(val)))
			)
				return true;
			if (val === '-') return true;
			if (!isNaN(Number(val)) && val !== 0 && Number(val) <= Number(ctx.parent.count_in_number)) return true;
		}),
	wasted: yup.number().nullable(),
});

export const preformOperationFillSchema = yup.object().shape({
	id: yup.number().required(),
	fio: yup.string().nullable(),
	date: yup.string().nullable(),
	count_in_number: yup.string().nullable().test('meters', '', testForMetersFormat),
	count_out_number: yup.string().nullable().test('meters', '', testForMetersFormat),
	wasted: yup.string().nullable().test('meters', '', testForMetersFormat),
});

export const issueDetailsPreformSchema = yup.object().shape({
	date: yup.string().nullable(),
	count: yup.string().nullable().test('meters', '', testForMetersFormat),
	fio_receiver: yup.string().nullable(),
	fio_sender: yup.string().nullable(),
	return_count: yup.string().nullable().test('meters', '', testForMetersFormat),
	return_date: yup.string().nullable(),
	fio_receiver_returned: yup.string().nullable(),
	product_tech_map_receiver_id: yup.number().required(),
	product_tech_map_receiver_number: yup.number().required(),
});
